import React from 'react';
import * as PropTypes from 'prop-types';
import {
  SectionHeaderWrapper,
  LeftWrapper,
  Icon,
  TextToolTip,
  ButtonToolTip,
  Text,
  Button,
} from './elements';

function SeH008(props) {
  return (
    <SectionHeaderWrapper className={props.className} color={props.color}>
      <LeftWrapper>
        <Icon icon={props.icon ? props.icon : 'icon-lock'} />
        {props.textTooltipText ? (
          <TextToolTip text={props.textTooltipText}>
            <Text>{props.text}</Text>
          </TextToolTip>
        ) : (
          <Text>{props.text}</Text>
        )}
      </LeftWrapper>
      {props.noButton ? null : props.buttonTooltipText ? (
        <ButtonToolTip text={props.buttonTooltipText}>
          <Button onClick={props.buttonOnClick}>{props.buttonText}</Button>
        </ButtonToolTip>
      ) : (
        <Button onClick={props.buttonOnClick}>{props.buttonText}</Button>
      )}
    </SectionHeaderWrapper>
  );
}
SeH008.propTypes = {
  className: PropTypes.string,
  textTooltipText: PropTypes.string,
  buttonTooltipText: PropTypes.string,
  text: PropTypes.string,
  buttonOnClick: PropTypes.func,
  buttonText: PropTypes.string,
};
export default SeH008;
